import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\SmsController::verify
 * @see app/Http/Controllers/SmsController.php:90
 * @route '/account/sms/update/verify'
 */
export const verify = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(options),
    method: 'post',
})

verify.definition = {
    methods: ["post"],
    url: '/account/sms/update/verify',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SmsController::verify
 * @see app/Http/Controllers/SmsController.php:90
 * @route '/account/sms/update/verify'
 */
verify.url = (options?: RouteQueryOptions) => {
    return verify.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SmsController::verify
 * @see app/Http/Controllers/SmsController.php:90
 * @route '/account/sms/update/verify'
 */
verify.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\SmsController::verify
 * @see app/Http/Controllers/SmsController.php:90
 * @route '/account/sms/update/verify'
 */
    const verifyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: verify.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\SmsController::verify
 * @see app/Http/Controllers/SmsController.php:90
 * @route '/account/sms/update/verify'
 */
        verifyForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: verify.url(options),
            method: 'post',
        })
    
    verify.form = verifyForm
const update = {
    verify: Object.assign(verify, verify),
}

export default update